import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { AuthService } from "src/app/services/auth/auth.service";


@Component({
  selector: 'app-unauthorized-v2',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './unauthorized-v2.component.html',
  styleUrl: './unauthorized-v2.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class UnauthorizedV2Component {
  constructor(private readonly auth: AuthService) {}
  
  logout() {
    this.auth.startSignoutMainWindow();
  }
}
